export const DOWNLOAD_URLS = {
  ios: 'https://apps.apple.com/ar/app/rollinews/id6514329548?l=en-GB',
  android: 'https://play.google.com/store/apps/details?id=com.rollinews',
};
